import React from "react";
import clsx from "clsx";

const SectionHeading = ({
  subtitle,
  title,
  textAlign = "center", // left | center | right
  containerClassName,
  subtitleClassName,
  titleClassName,
  actions,
}) => {
  const containerClasses = clsx(
    "w-full flex flex-col gap-y-4 sm:gap-y-8 md:gap-y-4 px-4 md:px-8 lg:px-12 ",
    {
      "items-start text-left": textAlign === "left",
      "items-center text-center": textAlign === "center",
      "items-end text-right": textAlign === "right",
    },

    containerClassName
  );

  const titleClasses = clsx(
    "font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-wide uppercase text-primaryTextColor",
    "lg:leading-[91px] leading-relaxed md:tracking-[0.02em]",
    titleClassName
  );

  const subtitleClasses = clsx(
    "font-subheading font-normal px-8 capitalize text-secondaryTextColor",
    "text-base sm:text-lg md:text-xl lg:text-2xl tracking-[0.02em] text-center max-w-6xl",
    subtitleClassName
  );

  return (
    <div className={containerClasses}>
      {title && <h1 className={titleClasses}>{title}</h1>}
      {subtitle && <h3 className={subtitleClasses}>{subtitle}</h3>}

      {actions && <div className="mt-4  flex gap-3">{actions}</div>}
      
    </div>
  );
};

export default SectionHeading;